import { RootState } from "integrations/redux"

export const root = (state: RootState) => state.map.layers
